import $ from "jquery";

$(function () {
	$("#AlertBanner-close").click(function(){
		$("#alert").addClass("AlertBanner-close");
	});
});
